module.exports = __webpack_public_path__ + "img/02_no.0a5b419a.svg";